export default __webpack_public_path__ + "static/Row 1.1_Myfirstskool-c02e04b2101906b2deaaed18044858a0.jpg";